import { useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

// Corrige le chemin vers les icônes
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

export default function Map() {
    useEffect(() => {
        const map = L.map("map").setView([43.638105, 3.861856], 15);

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(map);

        L.marker([43.638111, 3.861917])
            .addTo(map)
            .bindPopup('<div style="text-align: center;">Station Meteo<br/>43°38\'17.2"N 3°51\'42.7"E</div>')

            .openPopup();

        return () => map.remove();
    }, []);

    return (
        <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginTop: "20px", marginBottom: "20px" }}>
            <div id="map" style={{ width: "300px", height: "300px", borderRadius: "15px", overflow: "hidden"  }}></div>
        </div>
    );
}
